import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ArrowLeft from '@splashthat/doppler/icons/ArrowLeft';
import { buttonIconLargePadding } from 'common/styles/variables';

const StyledArrow = styled.a`
    color: ${({ isDark, theme }) => (isDark ? theme.palette.grayscale.black : theme.palette.grayscale.white)};
    padding: 1rem ${buttonIconLargePadding} 1rem 0;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    font-weight: bold;

    &:hover {
        color: ${({ isDark, theme }) => (isDark ? theme.palette.primary.main : theme.palette.grayscale.gray65)};
    }

    > *:not(:first-child) {
        padding-left: 1rem;
    }
`;

const StyledText = styled.span`
    /* Make the text height the same as the svg icon height
       to keep things vertically centered. */
    line-height: 24px;
`;

const ArrowLink = (props) => (
    <StyledArrow isDark={props.isDark} href={props.href} onClick={props.onClick}>
        <ArrowLeft />
        {props.text && <StyledText>{props.text}</StyledText>}
    </StyledArrow>
);

ArrowLink.propTypes = {
    isDark: PropTypes.bool,
    text: PropTypes.string,
    onClick: PropTypes.func,
    href: PropTypes.string.isRequired,
};

ArrowLink.defaultProps = {
    isDark: false,
    text: null,
    onClick: () => {},
};

export default ArrowLink;
